/**
 * Controls inline table/section loading via tableLoading.
 * Fullscreen overlay loaders are no longer used.
 */

function isQuiet(vm) {
  return Boolean(vm && vm._quietOverlayDepth > 0);
}

export function setOverlay(vm, show) {
  if (!vm) return;

  // Quiet/background mode: suppress every loader.
  if (isQuiet(vm)) {
    return;
  }

  if (show) {
    vm._tableLoadDepth = (vm._tableLoadDepth || 0) + 1;
    vm.tableLoading = true;
  } else {
    vm._tableLoadDepth = Math.max(0, (vm._tableLoadDepth || 1) - 1);
    if (vm._tableLoadDepth === 0) {
      vm.tableLoading = false;
    }
  }
}

export function silentLoad(vm, task) {
  if (!vm) {
    return Promise.resolve(typeof task === "function" ? task() : task);
  }

  vm._silentOverlayDepth = (vm._silentOverlayDepth || 0) + 1;

  let result;
  try {
    result = typeof task === "function" ? task() : task;
  } catch (error) {
    vm._silentOverlayDepth = Math.max(0, (vm._silentOverlayDepth || 1) - 1);
    return Promise.reject(error);
  }

  return Promise.resolve(result)
    .finally(() => {
      vm._silentOverlayDepth = Math.max(0, (vm._silentOverlayDepth || 1) - 1);
    });
}

export function loadBackground(vm, tasks) {
  const runners = (Array.isArray(tasks) ? tasks : [tasks]).map((task) =>
    typeof task === "function" ? task() : task,
  );
  return silentLoad(vm, () => Promise.all(runners));
}

/**
 * Runs a task while suppressing all loaders for the caller. setOverlay calls
 * made by APIs invoked inside the task become no-ops, so supporting data can
 * load without showing an inline loader. The caller drives any loader it wants.
 */
export function quietLoad(vm, task) {
  if (!vm) {
    return Promise.resolve(typeof task === "function" ? task() : task);
  }

  vm._quietOverlayDepth = (vm._quietOverlayDepth || 0) + 1;

  let result;
  try {
    result = typeof task === "function" ? task() : task;
  } catch (error) {
    vm._quietOverlayDepth = Math.max(0, (vm._quietOverlayDepth || 1) - 1);
    return Promise.reject(error);
  }

  return Promise.resolve(result)
    .finally(() => {
      vm._quietOverlayDepth = Math.max(0, (vm._quietOverlayDepth || 1) - 1);
    });
}
